// extracted by mini-css-extract-plugin
export default {"wrapper":"Hero-module--wrapper--kByju","container":"Hero-module--container--T+ENG","title":"Hero-module--title--LHdk-","subtitle":"Hero-module--subtitle--J6qoZ"};